import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: Date | string; output: Date; }
  DateNoLocale: { input: Date | string; output: Date; }
  LocalDateTime: { input: Date; output: Date; }
  Uuid: { input: string; output: string; }
};

export type AccountManager = {
  __typename?: 'AccountManager';
  email: Scalars['String']['output'];
  establishments: Array<UserEstablishment>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type AdditionalFilterFilterInput = {
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdditionalFilterInput = {
  filter: AdditionalFilterFilterInput;
  name: Scalars['String']['input'];
};

export type AdditionalFiltersValues = {
  __typename?: 'AdditionalFiltersValues';
  values: Array<Maybe<AdditionalFiltersValuesNamed>>;
};

export type AdditionalFiltersValuesNamed = {
  __typename?: 'AdditionalFiltersValuesNamed';
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type Address = {
  __typename?: 'Address';
  additional?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type Amount = {
  __typename?: 'Amount';
  currency: ECurrencyType;
  value: Scalars['Float']['output'];
};

export type AppScope = {
  __typename?: 'AppScope';
  appName?: Maybe<Scalars['String']['output']>;
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Maybe<Role>>>;
};

export type Billing = {
  __typename?: 'Billing';
  clientRate: Scalars['Float']['output'];
  currency: ECurrencyType;
  type?: Maybe<EBillingType>;
};

export type BillingInformation = {
  __typename?: 'BillingInformation';
  missionType?: Maybe<IMissionType>;
};

export type ClientSettings = {
  __typename?: 'ClientSettings';
  additionalFields: Array<SettingsAdditionals>;
  idClient: Scalars['String']['output'];
  masquedStats: Array<Scalars['String']['output']>;
  sirets: Array<Scalars['String']['output']>;
};

export type ConsumedBudgetStats = {
  __typename?: 'ConsumedBudgetStats';
  currentPeriod: StatsCharBarCurrentPeriod;
  previousPeriod?: Maybe<StatsPreviousPeriod>;
};

export type Contact = {
  __typename?: 'Contact';
  firstName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type Contractor = {
  __typename?: 'Contractor';
  firstName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  trigram?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['Uuid']['output'];
};

export type ContractorMissionStats = {
  __typename?: 'ContractorMissionStats';
  currentPeriod: StatsCharBarCurrentPeriod;
  previousPeriod?: Maybe<StatsPreviousPeriod>;
};

export type Customer = {
  __typename?: 'Customer';
  contact?: Maybe<Contact>;
  establishment?: Maybe<Establishment>;
};

export type DashboardType = {
  __typename?: 'DashboardType';
  averageCR: Scalars['Float']['output'];
  averageCRTendency: Scalars['Int']['output'];
  contractorsInMission: Scalars['Float']['output'];
  contractorsInMissionTendency: Scalars['Int']['output'];
  conversion: Scalars['Float']['output'];
  conversionTendency: Scalars['Int']['output'];
  currentPeriod: PeriodType;
  opportunities: Scalars['Int']['output'];
  opportunitiesTendency: Scalars['Int']['output'];
  previousAverageCR: Scalars['Float']['output'];
  previousContractorsInMission: Scalars['Float']['output'];
  previousConversion: Scalars['Float']['output'];
  previousOpportunities: Scalars['Int']['output'];
  previousPeriod: PeriodType;
  previousTotalInvoiced: Scalars['Float']['output'];
  totalInvoiced: Scalars['Float']['output'];
  totalInvoicedTendency: Scalars['Int']['output'];
};

export type DateRangeInput = {
  endAt?: InputMaybe<DateTimeFilterInput>;
  startAt?: InputMaybe<DateTimeFilterInput>;
};

export type DateTimeFilterInput = {
  /** After with the specified value. */
  after?: InputMaybe<Scalars['DateNoLocale']['input']>;
  /** After or equal with the specified value. */
  afterOrEqual?: InputMaybe<Scalars['DateNoLocale']['input']>;
  /** Before the specified value. */
  before?: InputMaybe<Scalars['DateNoLocale']['input']>;
  /** Before or equal to the specified value. */
  beforeOrEqual?: InputMaybe<Scalars['DateNoLocale']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['DateNoLocale']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<InputMaybe<Scalars['DateNoLocale']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['DateNoLocale']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateNoLocale']['input']>>>;
};

export type Delivery = {
  __typename?: 'Delivery';
  additionals: Array<DeliveryAdditionals>;
  billing?: Maybe<Billing>;
  billingInformation?: Maybe<BillingInformation>;
  customer?: Maybe<Customer>;
  endAt?: Maybe<Scalars['LocalDateTime']['output']>;
  invoiceAddress?: Maybe<Address>;
  invoices: Array<Invoice>;
  location?: Maybe<Location>;
  missionDurationInDays: Scalars['Float']['output'];
  orderRef: Scalars['String']['output'];
  provider?: Maybe<Provider>;
  purchaseOrders: Array<MissionDocument>;
  quotes: Array<MissionDocument>;
  reference: Scalars['String']['output'];
  renewals: Scalars['Int']['output'];
  startAt?: Maybe<Scalars['LocalDateTime']['output']>;
  status: EMissionStatus;
  totalBilling: TotalBilling;
  type: EMissionType;
};

export type DeliveryAdditionalField = {
  __typename?: 'DeliveryAdditionalField';
  columnId: Scalars['String']['output'];
  dateValue?: Maybe<Scalars['LocalDateTime']['output']>;
  label: Scalars['String']['output'];
  numberValue?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type DeliveryAdditionals = {
  __typename?: 'DeliveryAdditionals';
  category: Scalars['String']['output'];
  fields: Array<DeliveryAdditionalField>;
  hiddenPaths: Array<Scalars['String']['output']>;
};

export type DeliveryConnection = {
  __typename?: 'DeliveryConnection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<DeliveryEdge>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalUnfiltered: Scalars['Int']['output'];
};

export type DeliveryEdge = {
  __typename?: 'DeliveryEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: Delivery;
};

export type DeliveryFilter = {
  __typename?: 'DeliveryFilter';
  additionalfilters: AdditionalFiltersValues;
  department: DepartmentValues;
  operational: OperationalValues;
  status: Array<MissionStatusValuesType>;
  type: Array<MissionTypeValuesType>;
};

export type DeliveryFilterInput = {
  additionals?: InputMaybe<Array<InputMaybe<AdditionalFilterInput>>>;
  department?: InputMaybe<DepartmentFilterInput>;
  endAt?: InputMaybe<DateTimeFilterInput>;
  operational?: InputMaybe<OperationalFilterInput>;
  startAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<MissionStatusFilterInput>;
  type?: InputMaybe<MissionTypeFilterInput>;
};

export enum DeliveryOrderBy {
  StartAtAsc = 'START_AT_ASC',
  StartAtDsc = 'START_AT_DSC'
}

export type DepartmentFilterInput = {
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DepartmentValues = {
  __typename?: 'DepartmentValues';
  values: Array<Scalars['String']['output']>;
};

export enum EBillingType {
  Day = 'DAY',
  FlatRate = 'FLAT_RATE'
}

export enum EContentLanguageEnum {
  En = 'EN',
  Fr = 'FR'
}

export enum ECurrencyType {
  Adp = 'ADP',
  Aed = 'AED',
  Afa = 'AFA',
  Afn = 'AFN',
  Alk = 'ALK',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Aok = 'AOK',
  Aon = 'AON',
  Aor = 'AOR',
  Ara = 'ARA',
  Arp = 'ARP',
  Ars = 'ARS',
  Ary = 'ARY',
  Ats = 'ATS',
  Aud = 'AUD',
  Awg = 'AWG',
  Aym = 'AYM',
  Azm = 'AZM',
  Azn = 'AZN',
  Bad = 'BAD',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bec = 'BEC',
  Bef = 'BEF',
  Bel = 'BEL',
  Bgj = 'BGJ',
  Bgk = 'BGK',
  Bgl = 'BGL',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Bop = 'BOP',
  Bov = 'BOV',
  Brb = 'BRB',
  Brc = 'BRC',
  Bre = 'BRE',
  Brl = 'BRL',
  Brn = 'BRN',
  Brr = 'BRR',
  Bsd = 'BSD',
  Btn = 'BTN',
  Buk = 'BUK',
  Bwp = 'BWP',
  Byb = 'BYB',
  Byn = 'BYN',
  Byr = 'BYR',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Chc = 'CHC',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Cou = 'COU',
  Crc = 'CRC',
  Csd = 'CSD',
  Csj = 'CSJ',
  Csk = 'CSK',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Cyp = 'CYP',
  Czk = 'CZK',
  Ddm = 'DDM',
  Dem = 'DEM',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Ecs = 'ECS',
  Ecv = 'ECV',
  Eek = 'EEK',
  Egp = 'EGP',
  Ern = 'ERN',
  Esa = 'ESA',
  Esb = 'ESB',
  Esp = 'ESP',
  Etb = 'ETB',
  Eur = 'EUR',
  Fim = 'FIM',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Frf = 'FRF',
  Gbp = 'GBP',
  Gek = 'GEK',
  Gel = 'GEL',
  Ghc = 'GHC',
  Ghp = 'GHP',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gne = 'GNE',
  Gnf = 'GNF',
  Gns = 'GNS',
  Gqe = 'GQE',
  Grd = 'GRD',
  Gtq = 'GTQ',
  Gwe = 'GWE',
  Gwp = 'GWP',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrd = 'HRD',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Iep = 'IEP',
  Ilp = 'ILP',
  Ilr = 'ILR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isj = 'ISJ',
  Isk = 'ISK',
  Itl = 'ITL',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Laj = 'LAJ',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Lsm = 'LSM',
  Ltl = 'LTL',
  Ltt = 'LTT',
  Luc = 'LUC',
  Luf = 'LUF',
  Lul = 'LUL',
  Lvl = 'LVL',
  Lvr = 'LVR',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mgf = 'MGF',
  Mkd = 'MKD',
  Mlf = 'MLF',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mro = 'MRO',
  Mtl = 'MTL',
  Mtp = 'MTP',
  Mur = 'MUR',
  Mvq = 'MVQ',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Mxp = 'MXP',
  Mxv = 'MXV',
  Myr = 'MYR',
  Mze = 'MZE',
  Mzm = 'MZM',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nic = 'NIC',
  Nio = 'NIO',
  Nlg = 'NLG',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Peh = 'PEH',
  Pei = 'PEI',
  Pen = 'PEN',
  Pes = 'PES',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Plz = 'PLZ',
  Pte = 'PTE',
  Pyg = 'PYG',
  Qar = 'QAR',
  Rhd = 'RHD',
  Rok = 'ROK',
  Rol = 'ROL',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rur = 'RUR',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdd = 'SDD',
  Sdg = 'SDG',
  Sdp = 'SDP',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sit = 'SIT',
  Skk = 'SKK',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Srg = 'SRG',
  Ssp = 'SSP',
  Std = 'STD',
  Sur = 'SUR',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjr = 'TJR',
  Tjs = 'TJS',
  Tmm = 'TMM',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Tpe = 'TPE',
  Trl = 'TRL',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Uak = 'UAK',
  Ugs = 'UGS',
  Ugw = 'UGW',
  Ugx = 'UGX',
  Usd = 'USD',
  Usn = 'USN',
  Uss = 'USS',
  Uyi = 'UYI',
  Uyn = 'UYN',
  Uyp = 'UYP',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Veb = 'VEB',
  Vef = 'VEF',
  Vnc = 'VNC',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xag = 'XAG',
  Xau = 'XAU',
  Xba = 'XBA',
  Xbb = 'XBB',
  Xbc = 'XBC',
  Xbd = 'XBD',
  Xcd = 'XCD',
  Xdr = 'XDR',
  Xeu = 'XEU',
  Xfo = 'XFO',
  Xfu = 'XFU',
  Xof = 'XOF',
  Xpd = 'XPD',
  Xpf = 'XPF',
  Xpt = 'XPT',
  Xre = 'XRE',
  Xsu = 'XSU',
  Xts = 'XTS',
  Xua = 'XUA',
  Xxx = 'XXX',
  Ydd = 'YDD',
  Yer = 'YER',
  Yud = 'YUD',
  Yum = 'YUM',
  Yun = 'YUN',
  Zal = 'ZAL',
  Zar = 'ZAR',
  Zmk = 'ZMK',
  Zmw = 'ZMW',
  Zrn = 'ZRN',
  Zrz = 'ZRZ',
  Zwc = 'ZWC',
  Zwd = 'ZWD',
  Zwl = 'ZWL',
  Zwn = 'ZWN',
  Zwr = 'ZWR'
}

export enum EExportFormatEnum {
  Csv = 'CSV',
  Json = 'JSON',
  Xls = 'XLS'
}

export enum EExportOpportunitySourceEnum {
  OpportunitiesAt = 'OPPORTUNITIES_AT',
  OpportunitiesForfait = 'OPPORTUNITIES_FORFAIT'
}

export enum EExportRecurrenceEnum {
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Never = 'NEVER'
}

export enum EExportSourceEnum {
  Deliveries = 'DELIVERIES',
  Invoices = 'INVOICES',
  OpportunitiesAt = 'OPPORTUNITIES_AT',
  OpportunitiesForfait = 'OPPORTUNITIES_FORFAIT'
}

export enum EMissionDocument {
  PurchaseOrder = 'PURCHASE_ORDER',
  Quote = 'QUOTE'
}

export enum EMissionStatus {
  Aborted = 'ABORTED',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Terminated = 'TERMINATED',
  Validated = 'VALIDATED'
}

export enum EMissionType {
  Classic = 'CLASSIC',
  ResourceManagement = 'RESOURCE_MANAGEMENT'
}

export enum EOpportunityCandidateStatus {
  Demarrage = 'DEMARRAGE',
  NoGoCandidate = 'NO_GO_CANDIDATE',
  PropositionAuClient = 'PROPOSITION_AU_CLIENT',
  RejetClientApresSoutenance = 'REJET_CLIENT_APRES_SOUTENANCE',
  RejetClientSurCv = 'REJET_CLIENT_SUR_CV',
  Soutenance = 'SOUTENANCE'
}

export enum EOpportunityStatus {
  Commande = 'COMMANDE',
  Gagnee = 'GAGNEE',
  NegociationFinanciere = 'NEGOCIATION_FINANCIERE',
  NonQualifiee = 'NON_QUALIFIEE',
  Perdu = 'PERDU',
  PropositionEnvoyee = 'PROPOSITION_ENVOYEE',
  Qualifiee = 'QUALIFIEE',
  QualifieeEnAmont = 'QUALIFIEE_EN_AMONT',
  QualifieeEnAval = 'QUALIFIEE_EN_AVAL',
  SolutionIdentifiee = 'SOLUTION_IDENTIFIEE',
  SoutenanceEffectuee = 'SOUTENANCE_EFFECTUEE',
  SoutenancePlanifiee = 'SOUTENANCE_PLANIFIEE'
}

export enum EOpportunityType {
  At = 'AT',
  Forfait = 'FORFAIT'
}

export type Establishment = {
  __typename?: 'Establishment';
  businessName: Scalars['String']['output'];
  customer?: Maybe<EstablishmentCustomer>;
};

export type EstablishmentCustomer = {
  __typename?: 'EstablishmentCustomer';
  accountManager?: Maybe<Scalars['String']['output']>;
  invoiceAddress?: Maybe<Address>;
  shouldValidateCra?: Maybe<Scalars['Boolean']['output']>;
};

export type Feed = {
  __typename?: 'Feed';
  feedUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  items?: Maybe<Array<Maybe<FeedItemFreelanceComEvent | FeedItemYouTube>>>;
  publishedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<FeedType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FeedFilterInput = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type FeedItemFreelanceComEvent = FeedItemInterface & {
  __typename?: 'FeedItemFreelanceComEvent';
  id?: Maybe<Scalars['ID']['output']>;
  resolvedType?: Maybe<FeedItemTypename>;
  startAt: Scalars['LocalDateTime']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FeedItemInterface = {
  id?: Maybe<Scalars['ID']['output']>;
  resolvedType?: Maybe<FeedItemTypename>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FeedItemThumbnail = {
  __typename?: 'FeedItemThumbnail';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export enum FeedItemTypename {
  FeedItemFreelanceComEvent = 'FEED_ITEM_FREELANCE_COM_EVENT',
  FeedItemYoutube = 'FEED_ITEM_YOUTUBE'
}

export type FeedItemYouTube = FeedItemInterface & {
  __typename?: 'FeedItemYouTube';
  description: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  publishedAt: Scalars['LocalDateTime']['output'];
  resolvedType?: Maybe<FeedItemTypename>;
  thumbnail: FeedItemThumbnail;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  views: Scalars['Int']['output'];
};

export enum FeedType {
  FreelanceComEvents = 'FREELANCE_COM_EVENTS',
  YtFreelanceComPlaylistChangeMakers = 'YT_FREELANCE_COM_PLAYLIST_CHANGE_MAKERS'
}

export type IMissionType = {
  __typename?: 'IMissionType';
  label?: Maybe<EMissionType>;
};

export type Invoice = {
  __typename?: 'Invoice';
  activityPeriod?: Maybe<Scalars['LocalDateTime']['output']>;
  currency: Scalars['String']['output'];
  department: Scalars['String']['output'];
  establishment: Scalars['String']['output'];
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  issueAt?: Maybe<Scalars['LocalDateTime']['output']>;
  orderReference: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: InvoiceStatus;
  totalBeforeTaxes: Scalars['Float']['output'];
  totalWithTaxes: Scalars['Float']['output'];
  type: InvoiceType;
  uuid: Scalars['Uuid']['output'];
  workedDays?: Maybe<Scalars['Float']['output']>;
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<InvoiceEdge>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalUnfiltered: Scalars['Int']['output'];
};

export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: Invoice;
};

export type InvoiceFilterInput = {
  invoiceDate?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<InvoiceStatusFilterInput>;
  type?: InputMaybe<InvoiceTypeFilterInput>;
};

export enum InvoiceStatus {
  Cancelled = 'CANCELLED',
  Paid = 'PAID',
  Sent = 'SENT',
  Validated = 'VALIDATED'
}

export type InvoiceStatusFilterInput = {
  /** Equal to the specified value. */
  equalTo?: InputMaybe<InvoiceStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<InvoiceStatus>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<InvoiceStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<InvoiceStatus>>;
};

export enum InvoiceType {
  Customer = 'CUSTOMER',
  CustomerCreditNote = 'CUSTOMER_CREDIT_NOTE',
  CustomerExpense = 'CUSTOMER_EXPENSE',
  CustomerExpenseCreditNote = 'CUSTOMER_EXPENSE_CREDIT_NOTE',
  CustomerStandByDuty = 'CUSTOMER_STAND_BY_DUTY',
  CustomerStandByDutyCreditNote = 'CUSTOMER_STAND_BY_DUTY_CREDIT_NOTE'
}

export type InvoiceTypeFilterInput = {
  /** Equal to the specified value. */
  equalTo?: InputMaybe<InvoiceType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<InvoiceType>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<InvoiceType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<InvoiceType>>;
};

export type Location = {
  __typename?: 'Location';
  additional?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  businessUnit?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type MissionDocument = {
  __typename?: 'MissionDocument';
  dailyRateBeforeTaxes: Amount;
  endAt: Scalars['LocalDateTime']['output'];
  estimatedDays: Scalars['Float']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  orderAmountBeforeTaxes: Amount;
  pricing: EBillingType;
  reference: Scalars['String']['output'];
  startAt: Scalars['LocalDateTime']['output'];
  type: EMissionDocument;
};

export type MissionStatusFilterInput = {
  /** Equal to the specified value. */
  equalTo?: InputMaybe<EMissionStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<EMissionStatus>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<EMissionStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<EMissionStatus>>;
};

/** mission status enums */
export enum MissionStatusValuesType {
  Aborted = 'ABORTED',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Terminated = 'TERMINATED',
  Validated = 'VALIDATED'
}

export type MissionTypeFilterInput = {
  /** Equal to the specified value. */
  equalTo?: InputMaybe<EMissionType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<EMissionType>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<EMissionType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<EMissionType>>;
};

/** mission types enums */
export enum MissionTypeValuesType {
  Classic = 'CLASSIC',
  ResourceManagement = 'RESOURCE_MANAGEMENT'
}

export type Mutation = {
  __typename?: 'Mutation';
  AdminSettings?: Maybe<SettingsType>;
  DeliveriesExport?: Maybe<Scalars['Boolean']['output']>;
  InvoicesExport?: Maybe<Scalars['Boolean']['output']>;
  OpportunitiesExport?: Maybe<Scalars['Boolean']['output']>;
  Settings?: Maybe<UserSettings>;
};


export type MutationAdminSettingsArgs = {
  settings: InputSettings;
};


export type MutationDeliveriesExportArgs = {
  payload: InputDeliveriesExport;
};


export type MutationInvoicesExportArgs = {
  payload: InputInvoicesExport;
};


export type MutationOpportunitiesExportArgs = {
  payload: InputOpportunitiesExport;
};


export type MutationSettingsArgs = {
  export: InputUserExportSettings;
};

export type OperationalFilterInput = {
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Uuid']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Uuid']['input']>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Uuid']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Uuid']['input']>>;
};

export type OperationalValues = {
  __typename?: 'OperationalValues';
  values: Array<UserMinify>;
};

export type Opportunities = OpportunityInterface & {
  __typename?: 'Opportunities';
  dateCreated: Scalars['LocalDateTime']['output'];
  establishment: OpportunityEtablissement;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: EOpportunityStatus;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  type: EOpportunityType;
};

export type OpportunitiesConnection = {
  __typename?: 'OpportunitiesConnection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<OpportunitiesEdge>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalUnfiltered: Scalars['Int']['output'];
};

export type OpportunitiesEdge = {
  __typename?: 'OpportunitiesEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: Opportunities;
};

export type OpportunitiesFilterInput = {
  createdAt?: InputMaybe<DateTimeFilterInput>;
  idEstablishment?: InputMaybe<Array<Scalars['String']['input']>>;
  siret?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<EOpportunityStatus>>;
  type?: InputMaybe<EOpportunityType>;
};

export type Opportunity = OpportunityInterface & {
  __typename?: 'Opportunity';
  candidates?: Maybe<Array<OpportunityCandidate>>;
  contact?: Maybe<OpportunityContact>;
  dateCreated: Scalars['LocalDateTime']['output'];
  establishment: OpportunityEtablissement;
  id: Scalars['ID']['output'];
  masterAgreement?: Maybe<Scalars['String']['output']>;
  missionLocation?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phases?: Maybe<Array<OpportunityPhase>>;
  status: EOpportunityStatus;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  type: EOpportunityType;
};

export type OpportunityCandidate = {
  __typename?: 'OpportunityCandidate';
  candidateName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: EOpportunityCandidateStatus;
  title?: Maybe<Scalars['String']['output']>;
  tjm?: Maybe<Scalars['Float']['output']>;
};

export type OpportunityContact = {
  __typename?: 'OpportunityContact';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OpportunityEtablissement = {
  __typename?: 'OpportunityEtablissement';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  siret?: Maybe<Scalars['String']['output']>;
};

export type OpportunityFilterInput = {
  id: Scalars['ID']['input'];
};

export type OpportunityInterface = {
  dateCreated: Scalars['LocalDateTime']['output'];
  establishment: OpportunityEtablissement;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: EOpportunityStatus;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  type: EOpportunityType;
};

export type OpportunityPhase = {
  __typename?: 'OpportunityPhase';
  amount?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  durationUnit?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['LocalDateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  optionnal?: Maybe<Scalars['Boolean']['output']>;
  sellsPrice?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['LocalDateTime']['output']>;
};

/** PageInfo cursor, as defined in https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor corresponding to the last nodes in edges. Null if the connection is empty. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Used to indicate whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Used to indicate whether more edges exist prior to the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor corresponding to the first nodes in edges. Null if the connection is empty. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PeriodType = {
  __typename?: 'PeriodType';
  endAt: Scalars['LocalDateTime']['output'];
  startAt: Scalars['LocalDateTime']['output'];
};

export type Provider = {
  __typename?: 'Provider';
  contact?: Maybe<Contact>;
  contractor?: Maybe<Contractor>;
  establishment?: Maybe<Establishment>;
};

export type Query = {
  __typename?: 'Query';
  Dashboard: DashboardType;
  Deliveries: DeliveryConnection;
  DeliveryFilter?: Maybe<DeliveryFilter>;
  Feed: Feed;
  Invoices: InvoiceConnection;
  Me: User;
  Opportunities: OpportunitiesConnection;
  Opportunity: Opportunity;
  Settings: SettingsType;
  Stats: Stats;
};


export type QueryDeliveriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DeliveryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DeliveryOrderBy>;
};


export type QueryDeliveryFilterArgs = {
  filter?: InputMaybe<DeliveryFilterInput>;
};


export type QueryFeedArgs = {
  filter?: InputMaybe<FeedFilterInput>;
  type: FeedType;
};


export type QueryInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<InvoiceFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOpportunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OpportunitiesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOpportunityArgs = {
  filter: OpportunityFilterInput;
};


export type QueryStatsArgs = {
  filter?: InputMaybe<StatsFilterInput>;
};

export type SettingsAdditionalReplaceType = {
  __typename?: 'SettingsAdditionalReplaceType';
  category: Scalars['String']['output'];
  fields: Array<SettingsAdditionalsReplaceField>;
  hiddenPaths: Array<Scalars['String']['output']>;
};

export type SettingsAdditionalRule = {
  __typename?: 'SettingsAdditionalRule';
  checkChildren?: Maybe<Scalars['Boolean']['output']>;
  fields: Array<Scalars['String']['output']>;
  regex: Scalars['String']['output'];
  replace?: Maybe<SettingsAdditionalReplaceType>;
  separator?: Maybe<Scalars['String']['output']>;
};

export type SettingsAdditionals = {
  __typename?: 'SettingsAdditionals';
  error?: Maybe<Scalars['String']['output']>;
  rules: Array<SettingsAdditionalRule>;
  ruleset: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type SettingsAdditionalsReplaceField = {
  __typename?: 'SettingsAdditionalsReplaceField';
  dateValue?: Maybe<Scalars['LocalDateTime']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  numberValue?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type SettingsType = {
  __typename?: 'SettingsType';
  ClientSettings: Array<ClientSettings>;
};

export type Stats = {
  __typename?: 'Stats';
  CONSUMED_BUDGET?: Maybe<ConsumedBudgetStats>;
  CONTRACTOR_MISSION?: Maybe<ContractorMissionStats>;
  GENDER_DISTRIBUTION?: Maybe<StatsPie>;
  ORDERED_DISTRIBUTION?: Maybe<StatsPie>;
  TOTAL_BILLED?: Maybe<TotalBilledStats>;
};

export type StatsCharBar = {
  __typename?: 'StatsCharBar';
  labels?: Maybe<Array<Scalars['String']['output']>>;
  series: Array<Series>;
};

export type StatsCharBarCurrentPeriod = {
  __typename?: 'StatsCharBarCurrentPeriod';
  chart: StatsCharBar;
  total: Scalars['Float']['output'];
};

export type StatsFilterInput = {
  additionals?: InputMaybe<Array<InputMaybe<AdditionalFilterInput>>>;
  currentPeriod?: InputMaybe<DateRangeInput>;
  department?: InputMaybe<Scalars['String']['input']>;
  prestation?: InputMaybe<Scalars['String']['input']>;
  previousPeriod?: InputMaybe<DateRangeInput>;
};

export type StatsPie = {
  __typename?: 'StatsPie';
  series: Array<StatsPieSerie>;
};

export type StatsPieSerie = {
  __typename?: 'StatsPieSerie';
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type StatsPreviousPeriod = {
  __typename?: 'StatsPreviousPeriod';
  total: Scalars['Float']['output'];
};

export type TotalBilledStats = {
  __typename?: 'TotalBilledStats';
  currentPeriod: StatsCharBarCurrentPeriod;
  previousPeriod?: Maybe<StatsPreviousPeriod>;
};

export type TotalBilling = {
  __typename?: 'TotalBilling';
  remainingInvoicedDays: Scalars['Float']['output'];
  sumTotalInvoiceExpenses: Scalars['Float']['output'];
  sumTotalInvoiceServices: Scalars['Float']['output'];
  sumTotalInvoiceStandByDuties: Scalars['Float']['output'];
  sumTotalOrders: Scalars['Float']['output'];
  sumWorkedDaysServices: Scalars['Float']['output'];
  totalBilled: Scalars['Float']['output'];
  totalRemainingInvoiced: Scalars['Float']['output'];
};

export type User = {
  __typename?: 'User';
  accountManagers: Array<AccountManager>;
  appScopes?: Maybe<Array<Maybe<AppScope>>>;
  email: Scalars['String']['output'];
  establishments?: Maybe<Array<Maybe<UserEstablishment>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<UserSettings>;
  state: Scalars['String']['output'];
  uuid: Scalars['Uuid']['output'];
};

export type UserEstablishment = {
  __typename?: 'UserEstablishment';
  accountManager: AccountManager;
  businessName: Scalars['String']['output'];
  siret: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type UserMinify = {
  __typename?: 'UserMinify';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['Uuid']['output'];
};

export type InputClientSettings = {
  additionalFields: Array<InputSettingsAdditionals>;
  idClient: Scalars['String']['input'];
  masquedStats: Array<Scalars['String']['input']>;
  sirets: Array<Scalars['String']['input']>;
};

export type InputDeleteClientSettingsAdditionals = {
  idClient: Scalars['String']['input'];
};

export type InputDeliveriesExport = {
  columns: Array<InputUserExportColumn>;
  filter?: InputMaybe<DeliveryFilterInput>;
  format: EExportFormatEnum;
  locale: Scalars['String']['input'];
};

export type InputInvoicesExport = {
  columns: Array<InputUserExportColumn>;
  filter?: InputMaybe<InvoiceFilterInput>;
  format: EExportFormatEnum;
  locale: Scalars['String']['input'];
};

export type InputOpportunitiesExport = {
  columns: Array<InputUserExportColumn>;
  filter?: InputMaybe<OpportunitiesFilterInput>;
  format: EExportFormatEnum;
  locale: Scalars['String']['input'];
  source: EExportOpportunitySourceEnum;
};

export type InputSettings = {
  deleteClientSettings?: InputMaybe<InputDeleteClientSettingsAdditionals>;
  setClientSettings?: InputMaybe<InputClientSettings>;
};

export type InputSettingsAdditionalMatch = {
  fieldPath: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type InputSettingsAdditionalReplaceType = {
  category: Scalars['String']['input'];
  fields: Array<InputSettingsAdditionalsReplaceField>;
  hiddenPaths: Array<Scalars['String']['input']>;
};

export type InputSettingsAdditionalRule = {
  checkChildren?: InputMaybe<Scalars['Boolean']['input']>;
  fields: Array<Scalars['String']['input']>;
  regex: Scalars['String']['input'];
  replace?: InputMaybe<InputSettingsAdditionalReplaceType>;
  separator?: InputMaybe<Scalars['String']['input']>;
};

export type InputSettingsAdditionals = {
  error?: InputMaybe<Scalars['String']['input']>;
  match: InputSettingsAdditionalMatch;
  rules: Array<InputSettingsAdditionalRule>;
  ruleset: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export type InputSettingsAdditionalsReplaceField = {
  dateValue?: InputMaybe<Scalars['LocalDateTime']['input']>;
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export type InputUserExportColumn = {
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type InputUserExportSettings = {
  columns: Array<InputUserExportColumn>;
  format: EExportFormatEnum;
  locale?: InputMaybe<Scalars['String']['input']>;
  recurrence: EExportRecurrenceEnum;
};

export type InputUserSettings = {
  export?: InputMaybe<InputUserExportSettings>;
};

export type Role = {
  __typename?: 'role';
  name?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
};

export type Series = {
  __typename?: 'series';
  data: Array<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UserExportColumn = {
  __typename?: 'userExportColumn';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type UserExportSettings = {
  __typename?: 'userExportSettings';
  columns: Array<UserExportColumn>;
  format: EExportFormatEnum;
  locale?: Maybe<EContentLanguageEnum>;
  recurrence: EExportRecurrenceEnum;
};

export type UserSettings = {
  __typename?: 'userSettings';
  export?: Maybe<UserExportSettings>;
};

export type DeliveriesExportMutationVariables = Exact<{
  payload: InputDeliveriesExport;
}>;


export type DeliveriesExportMutation = { __typename?: 'Mutation', DeliveriesExport?: boolean | null };

export type InvoicesExportMutationVariables = Exact<{
  payload?: InputMaybe<InputInvoicesExport>;
}>;


export type InvoicesExportMutation = { __typename?: 'Mutation', InvoicesExport?: boolean | null };

export type OpportunitiesExportMutationVariables = Exact<{
  payload?: InputMaybe<InputOpportunitiesExport>;
}>;


export type OpportunitiesExportMutation = { __typename?: 'Mutation', OpportunitiesExport?: boolean | null };

export type SetUserSettingsMutationVariables = Exact<{
  export: InputUserExportSettings;
}>;


export type SetUserSettingsMutation = { __typename?: 'Mutation', Settings?: { __typename?: 'userSettings', export?: { __typename?: 'userExportSettings', format: EExportFormatEnum, recurrence: EExportRecurrenceEnum, columns: Array<{ __typename?: 'userExportColumn', id: string, label: string }> } | null } | null };

export type MissionDocumentFragment = { __typename?: 'MissionDocument', reference: string, type: EMissionDocument, startAt: Date, endAt: Date, pricing: EBillingType, fileUrl?: string | null, estimatedDays: number, dailyRateBeforeTaxes: { __typename?: 'Amount', currency: ECurrencyType, value: number }, orderAmountBeforeTaxes: { __typename?: 'Amount', value: number, currency: ECurrencyType } };

export type DeliveriesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DeliveryFilterInput>;
  orderBy?: InputMaybe<DeliveryOrderBy>;
}>;


export type DeliveriesQuery = { __typename?: 'Query', Deliveries: { __typename?: 'DeliveryConnection', totalCount: number, totalUnfiltered: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'DeliveryEdge', cursor: string, node: { __typename?: 'Delivery', reference: string, status: EMissionStatus, type: EMissionType, endAt?: Date | null, startAt?: Date | null, renewals: number, orderRef: string, missionDurationInDays: number, invoiceAddress?: { __typename?: 'Address', street?: string | null, city?: string | null, postalCode?: string | null, country?: string | null } | null, purchaseOrders: Array<{ __typename?: 'MissionDocument', reference: string, type: EMissionDocument, startAt: Date, endAt: Date, pricing: EBillingType, fileUrl?: string | null, estimatedDays: number, dailyRateBeforeTaxes: { __typename?: 'Amount', currency: ECurrencyType, value: number }, orderAmountBeforeTaxes: { __typename?: 'Amount', value: number, currency: ECurrencyType } }>, quotes: Array<{ __typename?: 'MissionDocument', reference: string, type: EMissionDocument, startAt: Date, endAt: Date, pricing: EBillingType, fileUrl?: string | null, estimatedDays: number, dailyRateBeforeTaxes: { __typename?: 'Amount', currency: ECurrencyType, value: number }, orderAmountBeforeTaxes: { __typename?: 'Amount', value: number, currency: ECurrencyType } }>, invoices: Array<{ __typename?: 'Invoice', status: InvoiceStatus, currency: string, type: InvoiceType, reference: string, orderReference: string, activityPeriod?: Date | null, workedDays?: number | null, issueAt?: Date | null, totalBeforeTaxes: number, invoiceUrl?: string | null }>, additionals: Array<{ __typename?: 'DeliveryAdditionals', category: string, hiddenPaths: Array<string>, fields: Array<{ __typename?: 'DeliveryAdditionalField', columnId: string, label: string, position?: number | null, dateValue?: Date | null, numberValue?: number | null, stringValue?: string | null }> }>, totalBilling: { __typename?: 'TotalBilling', sumTotalInvoiceExpenses: number, sumTotalInvoiceServices: number, sumTotalInvoiceStandByDuties: number, sumTotalOrders: number, sumWorkedDaysServices: number, totalBilled: number, remainingInvoicedDays: number, totalRemainingInvoiced: number }, customer?: { __typename?: 'Customer', establishment?: { __typename?: 'Establishment', businessName: string, customer?: { __typename?: 'EstablishmentCustomer', invoiceAddress?: { __typename?: 'Address', street?: string | null, city?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null, contact?: { __typename?: 'Contact', lastName?: string | null, firstName?: string | null } | null } | null, billing?: { __typename?: 'Billing', type?: EBillingType | null, clientRate: number, currency: ECurrencyType } | null, location?: { __typename?: 'Location', businessUnit?: string | null, street?: string | null, city?: string | null, postalCode?: string | null, country?: string | null, recipient?: string | null } | null, provider?: { __typename?: 'Provider', establishment?: { __typename?: 'Establishment', businessName: string } | null, contractor?: { __typename?: 'Contractor', trigram?: string | null, jobTitle?: string | null } | null, contact?: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null, jobTitle?: string | null } | null } | null } }> } };

export type DeliveriesFilterQueryVariables = Exact<{
  filter?: InputMaybe<DeliveryFilterInput>;
}>;


export type DeliveriesFilterQuery = { __typename?: 'Query', DeliveryFilter?: { __typename?: 'DeliveryFilter', type: Array<MissionTypeValuesType>, status: Array<MissionStatusValuesType>, department: { __typename?: 'DepartmentValues', values: Array<string> }, operational: { __typename?: 'OperationalValues', values: Array<{ __typename?: 'UserMinify', uuid: string, firstName?: string | null, lastName?: string | null, email: string }> }, additionalfilters: { __typename?: 'AdditionalFiltersValues', values: Array<{ __typename?: 'AdditionalFiltersValuesNamed', name: string, values: Array<string> } | null> } } | null };

export type FeedEventsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
}>;


export type FeedEventsQuery = { __typename?: 'Query', Feed: { __typename?: 'Feed', url?: string | null, items?: Array<{ __typename?: 'FeedItemFreelanceComEvent', startAt: Date, id?: string | null, url?: string | null, title?: string | null } | { __typename?: 'FeedItemYouTube', id?: string | null, url?: string | null, title?: string | null } | null> | null } };

export type HomeDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeDashboardQuery = { __typename?: 'Query', Dashboard: { __typename?: 'DashboardType', averageCR: number, averageCRTendency: number, contractorsInMission: number, contractorsInMissionTendency: number, conversion: number, conversionTendency: number, opportunities: number, opportunitiesTendency: number, totalInvoiced: number, totalInvoicedTendency: number, previousAverageCR: number, previousContractorsInMission: number, previousConversion: number, previousOpportunities: number, previousTotalInvoiced: number, previousPeriod: { __typename?: 'PeriodType', endAt: Date, startAt: Date } } };

export type HomeFeedQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeFeedQuery = { __typename?: 'Query', Feed: { __typename?: 'Feed', url?: string | null, items?: Array<{ __typename?: 'FeedItemFreelanceComEvent', startAt: Date, id?: string | null, url?: string | null, title?: string | null } | { __typename?: 'FeedItemYouTube', id?: string | null, url?: string | null, title?: string | null } | null> | null }, FeedYouTube: { __typename?: 'Feed', items?: Array<{ __typename?: 'FeedItemFreelanceComEvent', title?: string | null, url?: string | null } | { __typename?: 'FeedItemYouTube', views: number, publishedAt: Date, title?: string | null, url?: string | null } | null> | null } };

export type HomeManagersQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeManagersQuery = { __typename?: 'Query', Me: { __typename?: 'User', id: string, accountManagers: Array<{ __typename?: 'AccountManager', id: string, email: string, firstName: string, lastName: string, phone?: string | null, establishments: Array<{ __typename?: 'UserEstablishment', uuid: string, businessName: string }> }> } };

export type HomeTechnicalAssistancesQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeTechnicalAssistancesQuery = { __typename?: 'Query', TechnicalAssistances: { __typename?: 'OpportunitiesConnection', edges: Array<{ __typename?: 'OpportunitiesEdge', node: { __typename?: 'Opportunities', dateCreated: Date, id: string, name: string, status: EOpportunityStatus } }> } };

export type InvoicesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<InvoiceFilterInput>;
}>;


export type InvoicesQuery = { __typename?: 'Query', Invoices: { __typename?: 'InvoiceConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null }, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'Invoice', uuid: string, type: InvoiceType, department: string, status: InvoiceStatus, establishment: string, reference: string, totalWithTaxes: number, activityPeriod?: Date | null, issueAt?: Date | null, orderReference: string, workedDays?: number | null, totalBeforeTaxes: number, provider: string, currency: string, invoiceUrl?: string | null } }> } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', Me: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, appScopes?: Array<{ __typename?: 'AppScope', appName?: string | null, jobTitle?: string | null, roles?: Array<{ __typename?: 'role', name?: string | null, resource?: string | null } | null> | null } | null> | null, settings?: { __typename?: 'userSettings', export?: { __typename?: 'userExportSettings', format: EExportFormatEnum, recurrence: EExportRecurrenceEnum, columns: Array<{ __typename?: 'userExportColumn', id: string, label: string }> } | null } | null } };

export type OpportunitiesFragmentFragment = { __typename?: 'OpportunitiesConnection', totalCount: number, edges: Array<{ __typename?: 'OpportunitiesEdge', node: { __typename?: 'Opportunities', dateCreated: Date, id: string, name: string, status: EOpportunityStatus, totalAmount?: number | null, type: EOpportunityType, establishment: { __typename?: 'OpportunityEtablissement', name: string, siret?: string | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type FlatRatesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<EOpportunityStatus> | EOpportunityStatus>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
}>;


export type FlatRatesQuery = { __typename?: 'Query', FlatRates: { __typename?: 'OpportunitiesConnection', totalCount: number, edges: Array<{ __typename?: 'OpportunitiesEdge', node: { __typename?: 'Opportunities', dateCreated: Date, id: string, name: string, status: EOpportunityStatus, totalAmount?: number | null, type: EOpportunityType, establishment: { __typename?: 'OpportunityEtablissement', name: string, siret?: string | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type TechnicalAssistancesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<EOpportunityStatus> | EOpportunityStatus>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
}>;


export type TechnicalAssistancesQuery = { __typename?: 'Query', TechnicalAssistances: { __typename?: 'OpportunitiesConnection', totalCount: number, edges: Array<{ __typename?: 'OpportunitiesEdge', node: { __typename?: 'Opportunities', dateCreated: Date, id: string, name: string, status: EOpportunityStatus, totalAmount?: number | null, type: EOpportunityType, establishment: { __typename?: 'OpportunityEtablissement', name: string, siret?: string | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type OpportunityQueryVariables = Exact<{
  filter: OpportunityFilterInput;
}>;


export type OpportunityQuery = { __typename?: 'Query', Opportunity: { __typename?: 'Opportunity', dateCreated: Date, masterAgreement?: string | null, missionLocation?: string | null, name: string, status: EOpportunityStatus, totalAmount?: number | null, id: string, candidates?: Array<{ __typename?: 'OpportunityCandidate', id: string, name: string, tjm?: number | null, status: EOpportunityCandidateStatus }> | null, establishment: { __typename?: 'OpportunityEtablissement', name: string }, contact?: { __typename?: 'OpportunityContact', firstName: string, lastName: string } | null, phases?: Array<{ __typename?: 'OpportunityPhase', startDate?: Date | null, endDate?: Date | null, id: string, name: string, amount?: number | null }> | null } };

export type StatsQueryVariables = Exact<{
  filter?: InputMaybe<StatsFilterInput>;
}>;


export type StatsQuery = { __typename?: 'Query', Stats: { __typename?: 'Stats', TOTAL_BILLED?: { __typename?: 'TotalBilledStats', currentPeriod: { __typename?: 'StatsCharBarCurrentPeriod', total: number, chart: { __typename?: 'StatsCharBar', labels?: Array<string> | null, series: Array<{ __typename?: 'series', name?: string | null, data: Array<number> }> } }, previousPeriod?: { __typename?: 'StatsPreviousPeriod', total: number } | null } | null, CONSUMED_BUDGET?: { __typename?: 'ConsumedBudgetStats', currentPeriod: { __typename?: 'StatsCharBarCurrentPeriod', total: number, chart: { __typename?: 'StatsCharBar', labels?: Array<string> | null, series: Array<{ __typename?: 'series', name?: string | null, data: Array<number> }> } }, previousPeriod?: { __typename?: 'StatsPreviousPeriod', total: number } | null } | null, CONTRACTOR_MISSION?: { __typename?: 'ContractorMissionStats', currentPeriod: { __typename?: 'StatsCharBarCurrentPeriod', total: number, chart: { __typename?: 'StatsCharBar', labels?: Array<string> | null, series: Array<{ __typename?: 'series', name?: string | null, data: Array<number> }> } }, previousPeriod?: { __typename?: 'StatsPreviousPeriod', total: number } | null } | null, ORDERED_DISTRIBUTION?: { __typename?: 'StatsPie', series: Array<{ __typename?: 'StatsPieSerie', name: string, value: number }> } | null, GENDER_DISTRIBUTION?: { __typename?: 'StatsPie', series: Array<{ __typename?: 'StatsPieSerie', value: number, name: string }> } | null } };

export type StatsFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type StatsFilterQuery = { __typename?: 'Query', StatsFilter?: { __typename?: 'DeliveryFilter', department: { __typename?: 'DepartmentValues', values: Array<string> }, operational: { __typename?: 'OperationalValues', values: Array<{ __typename?: 'UserMinify', uuid: string, firstName?: string | null, lastName?: string | null }> } } | null };

export const MissionDocumentFragmentDoc = gql`
    fragment MissionDocument on MissionDocument {
  reference
  type
  startAt
  endAt
  pricing
  fileUrl
  estimatedDays
  dailyRateBeforeTaxes {
    currency
    value
  }
  orderAmountBeforeTaxes {
    value
    currency
  }
}
    `;
export const OpportunitiesFragmentFragmentDoc = gql`
    fragment OpportunitiesFragment on OpportunitiesConnection {
  edges {
    node {
      dateCreated
      establishment {
        name
        siret
      }
      id
      name
      status
      totalAmount
      type
    }
  }
  totalCount
  pageInfo {
    hasNextPage
    endCursor
  }
}
    `;
export const DeliveriesExportDocument = gql`
    mutation DeliveriesExport($payload: inputDeliveriesExport!) {
  DeliveriesExport(payload: $payload)
}
    `;
export type DeliveriesExportMutationFn = Apollo.MutationFunction<DeliveriesExportMutation, DeliveriesExportMutationVariables>;

/**
 * __useDeliveriesExportMutation__
 *
 * To run a mutation, you first call `useDeliveriesExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeliveriesExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deliveriesExportMutation, { data, loading, error }] = useDeliveriesExportMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useDeliveriesExportMutation(baseOptions?: Apollo.MutationHookOptions<DeliveriesExportMutation, DeliveriesExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeliveriesExportMutation, DeliveriesExportMutationVariables>(DeliveriesExportDocument, options);
      }
export type DeliveriesExportMutationHookResult = ReturnType<typeof useDeliveriesExportMutation>;
export type DeliveriesExportMutationResult = Apollo.MutationResult<DeliveriesExportMutation>;
export type DeliveriesExportMutationOptions = Apollo.BaseMutationOptions<DeliveriesExportMutation, DeliveriesExportMutationVariables>;
export const InvoicesExportDocument = gql`
    mutation InvoicesExport($payload: inputInvoicesExport = {format: CSV, columns: {id: "", label: ""}, locale: ""}) {
  InvoicesExport(payload: $payload)
}
    `;
export type InvoicesExportMutationFn = Apollo.MutationFunction<InvoicesExportMutation, InvoicesExportMutationVariables>;

/**
 * __useInvoicesExportMutation__
 *
 * To run a mutation, you first call `useInvoicesExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoicesExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoicesExportMutation, { data, loading, error }] = useInvoicesExportMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useInvoicesExportMutation(baseOptions?: Apollo.MutationHookOptions<InvoicesExportMutation, InvoicesExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoicesExportMutation, InvoicesExportMutationVariables>(InvoicesExportDocument, options);
      }
export type InvoicesExportMutationHookResult = ReturnType<typeof useInvoicesExportMutation>;
export type InvoicesExportMutationResult = Apollo.MutationResult<InvoicesExportMutation>;
export type InvoicesExportMutationOptions = Apollo.BaseMutationOptions<InvoicesExportMutation, InvoicesExportMutationVariables>;
export const OpportunitiesExportDocument = gql`
    mutation OpportunitiesExport($payload: inputOpportunitiesExport = {format: CSV, columns: {id: "", label: ""}, locale: "", source: OPPORTUNITIES_AT}) {
  OpportunitiesExport(payload: $payload)
}
    `;
export type OpportunitiesExportMutationFn = Apollo.MutationFunction<OpportunitiesExportMutation, OpportunitiesExportMutationVariables>;

/**
 * __useOpportunitiesExportMutation__
 *
 * To run a mutation, you first call `useOpportunitiesExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpportunitiesExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [opportunitiesExportMutation, { data, loading, error }] = useOpportunitiesExportMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useOpportunitiesExportMutation(baseOptions?: Apollo.MutationHookOptions<OpportunitiesExportMutation, OpportunitiesExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpportunitiesExportMutation, OpportunitiesExportMutationVariables>(OpportunitiesExportDocument, options);
      }
export type OpportunitiesExportMutationHookResult = ReturnType<typeof useOpportunitiesExportMutation>;
export type OpportunitiesExportMutationResult = Apollo.MutationResult<OpportunitiesExportMutation>;
export type OpportunitiesExportMutationOptions = Apollo.BaseMutationOptions<OpportunitiesExportMutation, OpportunitiesExportMutationVariables>;
export const SetUserSettingsDocument = gql`
    mutation SetUserSettings($export: inputUserExportSettings!) {
  Settings(export: $export) {
    export {
      columns {
        id
        label
      }
      format
      recurrence
    }
  }
}
    `;
export type SetUserSettingsMutationFn = Apollo.MutationFunction<SetUserSettingsMutation, SetUserSettingsMutationVariables>;

/**
 * __useSetUserSettingsMutation__
 *
 * To run a mutation, you first call `useSetUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserSettingsMutation, { data, loading, error }] = useSetUserSettingsMutation({
 *   variables: {
 *      export: // value for 'export'
 *   },
 * });
 */
export function useSetUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SetUserSettingsMutation, SetUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserSettingsMutation, SetUserSettingsMutationVariables>(SetUserSettingsDocument, options);
      }
export type SetUserSettingsMutationHookResult = ReturnType<typeof useSetUserSettingsMutation>;
export type SetUserSettingsMutationResult = Apollo.MutationResult<SetUserSettingsMutation>;
export type SetUserSettingsMutationOptions = Apollo.BaseMutationOptions<SetUserSettingsMutation, SetUserSettingsMutationVariables>;
export const DeliveriesDocument = gql`
    query Deliveries($first: Int!, $after: String, $filter: DeliveryFilterInput, $orderBy: DeliveryOrderBy) {
  Deliveries(first: $first, after: $after, filter: $filter, orderBy: $orderBy) {
    totalCount
    totalUnfiltered
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        reference
        status
        type
        endAt
        startAt
        renewals
        orderRef
        missionDurationInDays
        invoiceAddress {
          street
          city
          postalCode
          country
        }
        purchaseOrders {
          ...MissionDocument
        }
        quotes {
          ...MissionDocument
        }
        invoices {
          status
          currency
          type
          reference
          orderReference
          activityPeriod
          workedDays
          issueAt
          totalBeforeTaxes
          invoiceUrl
        }
        additionals {
          category
          fields {
            columnId
            label
            position
            dateValue
            numberValue
            stringValue
          }
          hiddenPaths
        }
        totalBilling {
          sumTotalInvoiceExpenses
          sumTotalInvoiceServices
          sumTotalInvoiceStandByDuties
          sumTotalOrders
          sumWorkedDaysServices
          totalBilled
          remainingInvoicedDays
          totalRemainingInvoiced
        }
        customer {
          establishment {
            businessName
            customer {
              invoiceAddress {
                street
                city
                postalCode
                country
              }
            }
          }
          contact {
            lastName
            firstName
          }
        }
        billing {
          type
          clientRate
          currency
        }
        location {
          businessUnit
          street
          city
          postalCode
          country
          recipient
        }
        provider {
          establishment {
            businessName
          }
          contractor {
            trigram
            jobTitle
          }
          contact {
            firstName
            lastName
            jobTitle
          }
        }
      }
    }
  }
}
    ${MissionDocumentFragmentDoc}`;

/**
 * __useDeliveriesQuery__
 *
 * To run a query within a React component, call `useDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDeliveriesQuery(baseOptions: Apollo.QueryHookOptions<DeliveriesQuery, DeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveriesQuery, DeliveriesQueryVariables>(DeliveriesDocument, options);
      }
export function useDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveriesQuery, DeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveriesQuery, DeliveriesQueryVariables>(DeliveriesDocument, options);
        }
export type DeliveriesQueryHookResult = ReturnType<typeof useDeliveriesQuery>;
export type DeliveriesLazyQueryHookResult = ReturnType<typeof useDeliveriesLazyQuery>;
export type DeliveriesQueryResult = Apollo.QueryResult<DeliveriesQuery, DeliveriesQueryVariables>;
export const DeliveriesFilterDocument = gql`
    query DeliveriesFilter($filter: DeliveryFilterInput) {
  DeliveryFilter(filter: $filter) {
    type
    status
    department {
      values
    }
    operational {
      values {
        uuid
        firstName
        lastName
        email
      }
    }
    additionalfilters {
      values {
        name
        values
      }
    }
  }
}
    `;

/**
 * __useDeliveriesFilterQuery__
 *
 * To run a query within a React component, call `useDeliveriesFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveriesFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveriesFilterQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeliveriesFilterQuery(baseOptions?: Apollo.QueryHookOptions<DeliveriesFilterQuery, DeliveriesFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveriesFilterQuery, DeliveriesFilterQueryVariables>(DeliveriesFilterDocument, options);
      }
export function useDeliveriesFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveriesFilterQuery, DeliveriesFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveriesFilterQuery, DeliveriesFilterQueryVariables>(DeliveriesFilterDocument, options);
        }
export type DeliveriesFilterQueryHookResult = ReturnType<typeof useDeliveriesFilterQuery>;
export type DeliveriesFilterLazyQueryHookResult = ReturnType<typeof useDeliveriesFilterLazyQuery>;
export type DeliveriesFilterQueryResult = Apollo.QueryResult<DeliveriesFilterQuery, DeliveriesFilterQueryVariables>;
export const FeedEventsDocument = gql`
    query FeedEvents($first: Int!) {
  Feed(type: FREELANCE_COM_EVENTS, filter: {first: $first}) {
    url
    items {
      id
      url
      title
      ... on FeedItemFreelanceComEvent {
        startAt
      }
    }
  }
}
    `;

/**
 * __useFeedEventsQuery__
 *
 * To run a query within a React component, call `useFeedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedEventsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFeedEventsQuery(baseOptions: Apollo.QueryHookOptions<FeedEventsQuery, FeedEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedEventsQuery, FeedEventsQueryVariables>(FeedEventsDocument, options);
      }
export function useFeedEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedEventsQuery, FeedEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedEventsQuery, FeedEventsQueryVariables>(FeedEventsDocument, options);
        }
export type FeedEventsQueryHookResult = ReturnType<typeof useFeedEventsQuery>;
export type FeedEventsLazyQueryHookResult = ReturnType<typeof useFeedEventsLazyQuery>;
export type FeedEventsQueryResult = Apollo.QueryResult<FeedEventsQuery, FeedEventsQueryVariables>;
export const HomeDashboardDocument = gql`
    query HomeDashboard {
  Dashboard {
    averageCR
    averageCRTendency
    contractorsInMission
    contractorsInMissionTendency
    conversion
    conversionTendency
    opportunities
    opportunitiesTendency
    totalInvoiced
    totalInvoicedTendency
    previousAverageCR
    previousContractorsInMission
    previousConversion
    previousOpportunities
    previousTotalInvoiced
    previousPeriod {
      endAt
      startAt
    }
  }
}
    `;

/**
 * __useHomeDashboardQuery__
 *
 * To run a query within a React component, call `useHomeDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeDashboardQuery(baseOptions?: Apollo.QueryHookOptions<HomeDashboardQuery, HomeDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeDashboardQuery, HomeDashboardQueryVariables>(HomeDashboardDocument, options);
      }
export function useHomeDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeDashboardQuery, HomeDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeDashboardQuery, HomeDashboardQueryVariables>(HomeDashboardDocument, options);
        }
export type HomeDashboardQueryHookResult = ReturnType<typeof useHomeDashboardQuery>;
export type HomeDashboardLazyQueryHookResult = ReturnType<typeof useHomeDashboardLazyQuery>;
export type HomeDashboardQueryResult = Apollo.QueryResult<HomeDashboardQuery, HomeDashboardQueryVariables>;
export const HomeFeedDocument = gql`
    query HomeFeed {
  Feed(type: FREELANCE_COM_EVENTS, filter: {first: 3}) {
    url
    items {
      id
      url
      title
      ... on FeedItemFreelanceComEvent {
        startAt
      }
    }
  }
  FeedYouTube: Feed(
    type: YT_FREELANCE_COM_PLAYLIST_CHANGE_MAKERS
    filter: {first: 1}
  ) {
    items {
      title
      url
      ... on FeedItemYouTube {
        views
        publishedAt
      }
    }
  }
}
    `;

/**
 * __useHomeFeedQuery__
 *
 * To run a query within a React component, call `useHomeFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeFeedQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeFeedQuery(baseOptions?: Apollo.QueryHookOptions<HomeFeedQuery, HomeFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeFeedQuery, HomeFeedQueryVariables>(HomeFeedDocument, options);
      }
export function useHomeFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeFeedQuery, HomeFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeFeedQuery, HomeFeedQueryVariables>(HomeFeedDocument, options);
        }
export type HomeFeedQueryHookResult = ReturnType<typeof useHomeFeedQuery>;
export type HomeFeedLazyQueryHookResult = ReturnType<typeof useHomeFeedLazyQuery>;
export type HomeFeedQueryResult = Apollo.QueryResult<HomeFeedQuery, HomeFeedQueryVariables>;
export const HomeManagersDocument = gql`
    query HomeManagers {
  Me {
    id
    accountManagers {
      id
      email
      firstName
      lastName
      phone
      establishments {
        uuid
        businessName
      }
    }
  }
}
    `;

/**
 * __useHomeManagersQuery__
 *
 * To run a query within a React component, call `useHomeManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeManagersQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeManagersQuery(baseOptions?: Apollo.QueryHookOptions<HomeManagersQuery, HomeManagersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeManagersQuery, HomeManagersQueryVariables>(HomeManagersDocument, options);
      }
export function useHomeManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeManagersQuery, HomeManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeManagersQuery, HomeManagersQueryVariables>(HomeManagersDocument, options);
        }
export type HomeManagersQueryHookResult = ReturnType<typeof useHomeManagersQuery>;
export type HomeManagersLazyQueryHookResult = ReturnType<typeof useHomeManagersLazyQuery>;
export type HomeManagersQueryResult = Apollo.QueryResult<HomeManagersQuery, HomeManagersQueryVariables>;
export const HomeTechnicalAssistancesDocument = gql`
    query HomeTechnicalAssistances {
  TechnicalAssistances: Opportunities(
    first: 3
    filter: {type: AT, status: [NEGOCIATION_FINANCIERE, NON_QUALIFIEE, PROPOSITION_ENVOYEE, QUALIFIEE_EN_AMONT, QUALIFIEE, SOLUTION_IDENTIFIEE, QUALIFIEE_EN_AVAL, SOUTENANCE_EFFECTUEE, SOUTENANCE_PLANIFIEE]}
  ) {
    edges {
      node {
        dateCreated
        id
        name
        status
      }
    }
  }
}
    `;

/**
 * __useHomeTechnicalAssistancesQuery__
 *
 * To run a query within a React component, call `useHomeTechnicalAssistancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeTechnicalAssistancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeTechnicalAssistancesQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeTechnicalAssistancesQuery(baseOptions?: Apollo.QueryHookOptions<HomeTechnicalAssistancesQuery, HomeTechnicalAssistancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeTechnicalAssistancesQuery, HomeTechnicalAssistancesQueryVariables>(HomeTechnicalAssistancesDocument, options);
      }
export function useHomeTechnicalAssistancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeTechnicalAssistancesQuery, HomeTechnicalAssistancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeTechnicalAssistancesQuery, HomeTechnicalAssistancesQueryVariables>(HomeTechnicalAssistancesDocument, options);
        }
export type HomeTechnicalAssistancesQueryHookResult = ReturnType<typeof useHomeTechnicalAssistancesQuery>;
export type HomeTechnicalAssistancesLazyQueryHookResult = ReturnType<typeof useHomeTechnicalAssistancesLazyQuery>;
export type HomeTechnicalAssistancesQueryResult = Apollo.QueryResult<HomeTechnicalAssistancesQuery, HomeTechnicalAssistancesQueryVariables>;
export const InvoicesDocument = gql`
    query Invoices($first: Int!, $after: String, $filter: InvoiceFilterInput) {
  Invoices(first: $first, after: $after, filter: $filter) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
    edges {
      node {
        uuid
        type
        department
        status
        establishment
        reference
        totalWithTaxes
        activityPeriod
        issueAt
        orderReference
        workedDays
        totalBeforeTaxes
        provider
        currency
        invoiceUrl
      }
    }
  }
}
    `;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const MeDocument = gql`
    query Me {
  Me {
    id
    email
    firstName
    lastName
    appScopes {
      roles {
        name
        resource
      }
      appName
      jobTitle
    }
    settings {
      export {
        columns {
          id
          label
        }
        format
        recurrence
      }
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const FlatRatesDocument = gql`
    query FlatRates($first: Int!, $after: String, $status: [EOpportunityStatus!], $createdAt: DateTimeFilterInput) {
  FlatRates: Opportunities(
    first: $first
    after: $after
    filter: {type: FORFAIT, status: $status, createdAt: $createdAt}
  ) {
    ...OpportunitiesFragment
  }
}
    ${OpportunitiesFragmentFragmentDoc}`;

/**
 * __useFlatRatesQuery__
 *
 * To run a query within a React component, call `useFlatRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlatRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlatRatesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *      createdAt: // value for 'createdAt'
 *   },
 * });
 */
export function useFlatRatesQuery(baseOptions: Apollo.QueryHookOptions<FlatRatesQuery, FlatRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlatRatesQuery, FlatRatesQueryVariables>(FlatRatesDocument, options);
      }
export function useFlatRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlatRatesQuery, FlatRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlatRatesQuery, FlatRatesQueryVariables>(FlatRatesDocument, options);
        }
export type FlatRatesQueryHookResult = ReturnType<typeof useFlatRatesQuery>;
export type FlatRatesLazyQueryHookResult = ReturnType<typeof useFlatRatesLazyQuery>;
export type FlatRatesQueryResult = Apollo.QueryResult<FlatRatesQuery, FlatRatesQueryVariables>;
export const TechnicalAssistancesDocument = gql`
    query TechnicalAssistances($first: Int!, $after: String, $status: [EOpportunityStatus!], $createdAt: DateTimeFilterInput) {
  TechnicalAssistances: Opportunities(
    first: $first
    after: $after
    filter: {type: AT, status: $status, createdAt: $createdAt}
  ) {
    ...OpportunitiesFragment
  }
}
    ${OpportunitiesFragmentFragmentDoc}`;

/**
 * __useTechnicalAssistancesQuery__
 *
 * To run a query within a React component, call `useTechnicalAssistancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTechnicalAssistancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTechnicalAssistancesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *      createdAt: // value for 'createdAt'
 *   },
 * });
 */
export function useTechnicalAssistancesQuery(baseOptions: Apollo.QueryHookOptions<TechnicalAssistancesQuery, TechnicalAssistancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TechnicalAssistancesQuery, TechnicalAssistancesQueryVariables>(TechnicalAssistancesDocument, options);
      }
export function useTechnicalAssistancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TechnicalAssistancesQuery, TechnicalAssistancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TechnicalAssistancesQuery, TechnicalAssistancesQueryVariables>(TechnicalAssistancesDocument, options);
        }
export type TechnicalAssistancesQueryHookResult = ReturnType<typeof useTechnicalAssistancesQuery>;
export type TechnicalAssistancesLazyQueryHookResult = ReturnType<typeof useTechnicalAssistancesLazyQuery>;
export type TechnicalAssistancesQueryResult = Apollo.QueryResult<TechnicalAssistancesQuery, TechnicalAssistancesQueryVariables>;
export const OpportunityDocument = gql`
    query Opportunity($filter: OpportunityFilterInput!) {
  Opportunity(filter: $filter) {
    candidates {
      id
      name
      tjm
      status
    }
    dateCreated
    establishment {
      name
    }
    masterAgreement
    missionLocation
    name
    status
    totalAmount
    id
    contact {
      firstName
      lastName
    }
    phases {
      startDate
      endDate
      id
      name
      amount
    }
  }
}
    `;

/**
 * __useOpportunityQuery__
 *
 * To run a query within a React component, call `useOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOpportunityQuery(baseOptions: Apollo.QueryHookOptions<OpportunityQuery, OpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityQuery, OpportunityQueryVariables>(OpportunityDocument, options);
      }
export function useOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityQuery, OpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityQuery, OpportunityQueryVariables>(OpportunityDocument, options);
        }
export type OpportunityQueryHookResult = ReturnType<typeof useOpportunityQuery>;
export type OpportunityLazyQueryHookResult = ReturnType<typeof useOpportunityLazyQuery>;
export type OpportunityQueryResult = Apollo.QueryResult<OpportunityQuery, OpportunityQueryVariables>;
export const StatsDocument = gql`
    query Stats($filter: StatsFilterInput) {
  Stats(filter: $filter) {
    TOTAL_BILLED {
      currentPeriod {
        total
        chart {
          series {
            name
            data
          }
          labels
        }
      }
      previousPeriod {
        total
      }
    }
    CONSUMED_BUDGET {
      currentPeriod {
        total
        chart {
          series {
            name
            data
          }
          labels
        }
      }
      previousPeriod {
        total
      }
    }
    CONTRACTOR_MISSION {
      currentPeriod {
        total
        chart {
          series {
            name
            data
          }
          labels
        }
      }
      previousPeriod {
        total
      }
    }
    ORDERED_DISTRIBUTION {
      series {
        name
        value
      }
    }
    GENDER_DISTRIBUTION {
      series {
        value
        name
      }
    }
  }
}
    `;

/**
 * __useStatsQuery__
 *
 * To run a query within a React component, call `useStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useStatsQuery(baseOptions?: Apollo.QueryHookOptions<StatsQuery, StatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatsQuery, StatsQueryVariables>(StatsDocument, options);
      }
export function useStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatsQuery, StatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatsQuery, StatsQueryVariables>(StatsDocument, options);
        }
export type StatsQueryHookResult = ReturnType<typeof useStatsQuery>;
export type StatsLazyQueryHookResult = ReturnType<typeof useStatsLazyQuery>;
export type StatsQueryResult = Apollo.QueryResult<StatsQuery, StatsQueryVariables>;
export const StatsFilterDocument = gql`
    query StatsFilter {
  StatsFilter: DeliveryFilter {
    department {
      values
    }
    operational {
      values {
        uuid
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useStatsFilterQuery__
 *
 * To run a query within a React component, call `useStatsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatsFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useStatsFilterQuery(baseOptions?: Apollo.QueryHookOptions<StatsFilterQuery, StatsFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatsFilterQuery, StatsFilterQueryVariables>(StatsFilterDocument, options);
      }
export function useStatsFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatsFilterQuery, StatsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatsFilterQuery, StatsFilterQueryVariables>(StatsFilterDocument, options);
        }
export type StatsFilterQueryHookResult = ReturnType<typeof useStatsFilterQuery>;
export type StatsFilterLazyQueryHookResult = ReturnType<typeof useStatsFilterLazyQuery>;
export type StatsFilterQueryResult = Apollo.QueryResult<StatsFilterQuery, StatsFilterQueryVariables>;